import 'reflect-metadata'
import { CroptypeDto } from './croptype'
import { IsArray, IsBoolean, IsNotEmpty, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator'
import { plainToInstance, Type } from 'class-transformer'

export class Variety {
  id: number | undefined
  name: string | undefined
  active: boolean | undefined
  croptype?: Pick<CroptypeDto, 'id' | 'key'> | undefined
  cropType?: string
  varietyCode?: string
  commercialOrTrial?: string
  varietalType?: string
  processingType?: string
  types?: VarietyTypes[]

  constructor(variety: Variety) {
    this.id = variety?.id
    this.name = variety?.name
    this.active = variety?.active ?? true
    this.croptype = variety?.croptype
    this.cropType = variety?.cropType
    this.varietyCode = variety?.varietyCode
    this.commercialOrTrial = variety?.commercialOrTrial
    this.varietalType = variety.varietalType
    this.processingType = variety?.processingType
    this.types = variety?.types
  }
}

export interface VarietyDto {
  id: number
  name: string
  active: boolean
  croptypeId: number
  croptypeKey: string
  varietyCode?: string
  commercialOrTrial?: string
  varietalType?: string
  processingType?: string
  types?: VarietyTypes[]
}

export class VarietyDAO {
  id!: number
  name!: string
  active!: boolean
  croptypeId!: number
  croptypeKey!: string
  varietyCode?: string
  commercialOrTrial?: string
  varietalType?: string
  processingType?: string
}

export class VarietyTypes {
  id?: number
  varietalType!: string
  processingType: string | undefined
  regionId!: number
}

export class SaveVariety {
  public static build(raw: any) {
    return plainToInstance(SaveVariety, raw)
  }

  @IsNumber()
  @IsOptional()
  id?: number

  @IsString()
  @IsNotEmpty()
  name: string | undefined

  @IsBoolean()
  @IsNotEmpty()
  active: boolean

  @IsNumber()
  @IsNumber()
  cropTypeId: number | undefined

  @IsString()
  @IsOptional()
  varietyCode?: string

  @IsString()
  @IsOptional()
  commercialOrTrial?: string

  @IsArray()
  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => VarietyTypes)
  types?: VarietyTypes[]

  constructor(variety?: SaveVariety) {
    if (variety?.id) {
      this.id = variety.id
    }

    this.name = variety?.name
    this.cropTypeId = variety?.cropTypeId
    this.active = variety?.active ?? false
    this.varietyCode = variety?.varietyCode
    this.commercialOrTrial = variety?.commercialOrTrial
    this.types = variety?.types
  }
}
